import React, { useState, useEffect } from "react"
import { Row, Card, CardBody, Spinner } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { useSelector } from "react-redux"
import axios from "axios"

const ProfileViewsChart = () => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const mode = useSelector(state => state.Layout.layoutMode)
  const [isLoading, setIsLoading] = useState(false)
  const [chartData, setChartData] = useState({
    options: {
      colors: ["#2990DF"],
      chart: {
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: [], // Days
      },
      yaxis: {
        title: {
          text: "Profile Views",
        },
      },
    },
    series: [
      {
        name: "Profile Views",
        data: [], // Daily profile views
      },
    ],
  })

  const fetchDailyData = async () => {
    try {
      setIsLoading(true)

      const now = new Date()
      const thirtyDaysAgo = new Date()
      thirtyDaysAgo.setDate(now.getDate() - 30)

      const dateRanges = []
      let current = new Date(thirtyDaysAgo)

      // Create date ranges for each day
      while (current <= now) {
        const startOfDay = new Date(current)
        startOfDay.setHours(0, 0, 0, 0)

        const endOfDay = new Date(current)
        endOfDay.setHours(23, 59, 59, 999)

        dateRanges.push({
          since: Math.floor(startOfDay.getTime() / 1000),
          until: Math.floor(endOfDay.getTime() / 1000),
          label: startOfDay.toLocaleDateString("default", {
            weekday: "short",
            day: "numeric",
            month: "short",
          }),
        })

        current.setDate(current.getDate() + 1)
      }

      const dailyCategories = []
      const dailyValues = []

      // Fetch data for each day
      for (const range of dateRanges) {
        const response = await axios.get(
          `https://graph.facebook.com/v21.0/${activeOrganization.InstagramIntegrations[0].pageId}/insights`,
          {
            params: {
              metric: "profile_views",
              metric_type: "total_value",
              period: "day",
              since: range.since,
              until: range.until,
              access_token:
                activeOrganization.InstagramIntegrations[0].pageToken,
            },
          },
        )

        const dailyValue = response.data?.data[0]?.total_value?.value || 0

        dailyCategories.push(range.label)
        dailyValues.push(dailyValue)
      }

      setChartData({
        options: {
          ...chartData.options,
          xaxis: {
            ...chartData.options.xaxis,
            categories: dailyCategories,
          },
        },
        series: [
          {
            name: "Profile Views",
            data: dailyValues,
          },
        ],
      })
    } catch (err) {
      console.error(
        "Error fetching Instagram insights:",
        err.response?.data || err.message,
      )
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchDailyData()
  }, [activeOrganization])

  return (
    <Card style={{ minHeight: "350px" }} className="br">
      {isLoading ? (
        <div
          style={{
            minHeight: "350px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner
            size="lg"
            style={{
              color: mode === "dark" ? "#fff" : "#2990DF",
            }}
          />
        </div>
      ) : (
        <CardBody>
          <h4 className="card-title mb-4">
            Instagram Profile Views (Last 30 Days)
          </h4>
          <Row>
            {/* Chart */}
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="line"
              height="290"
            />
          </Row>
        </CardBody>
      )}
    </Card>
  )
}

export default ProfileViewsChart
